<template>
  <v-dialog overlay-opacity="0.6" persistent max-width="800" :value="value">
    <!-- @input is required to emit emit input if clicked outside unless we use persistent -->
    <v-container fill-height fluid grid-list-xl>
      <v-layout justify-center wrap>
        <v-flex md12>
          <v-card class="ma-0 pa-2">
          <v-toolbar color="primary" dark>
              <v-app-bar-nav-icon
                ><v-icon large>mdi-account</v-icon>
              </v-app-bar-nav-icon>

              <v-toolbar-title>Modifica utente</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon @click="closeDialog" large>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

        
            <v-form class="mt-5" v-if="!fetchingData" ref="user-editor-form">
              <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
                <ValidationProvider
                  :immediate="editingUser"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    v-model="user.first_name"
                    label="Nome"
                    prepend-icon="mdi-account"
                    :error-messages="errors"
                    :success="valid"
                    required
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  :immediate="editingUser"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    v-model="user.last_name"
                    label="Cognome"
                    prepend-icon="mdi-account"
                    :error-messages="errors"
                    :success="valid"
                    required
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider
                  :immediate="editingUser"
                  rules="required|email"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    autocomplete="email"
                    v-model="user.email"
                    label="E-mail"
                    prepend-icon="mdi-email"
                    :error-messages="errors"
                    :success="valid"
                    required
                  ></v-text-field>
                </ValidationProvider>


                <ValidationProvider
                  :immediate="editingUser"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <v-select
                    v-model="user.roles"
                    outlined
                    label="Ruolo"
                    item-text="name"
                    item-value="value"
                    :items="roles"
                    :error-messages="errors"
                    :success="valid"
                    required
                  >
                  </v-select>
                </ValidationProvider>

                <ValidationProvider
                  v-if="!editingUser"
                  rules="required"
                  v-slot="{ errors, valid }"
                  vid="password_confirm"
                >
                  <v-text-field
                    autocomplete="new-password"
                    v-model="user.password"
                    prepend-icon="mdi-lock"
                    label="Password"
                    :append-icon="password_view ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (password_view = !password_view)"
                    :type="password_view ? 'password' : 'text'"
                    :error-messages="errors"
                    :success="valid"
                    required
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  v-if="!editingUser"
                  rules="required|confirmed:password_confirm"
                  v-slot="{ errors, valid }"
                >
                  <v-text-field
                    v-model="repeat_password"
                    prepend-icon="mdi-lock"
                    label="Ripeti password"
                    :error-messages="errors"
                    :append-icon="password_confirm ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (password_confirm = !password_confirm)"
                    :type="password_confirm ? 'password' : 'text'"
                    :success="valid"
                    required
                  ></v-text-field>
                </ValidationProvider>

                <div>
                  <span
                    v-if="!email_state"
                    style="color:red; margin-left: 30px;"
                    >E-mail già registrata</span
                  >
                </div>
                <v-row class="text-center">
                  <v-col>
                    <v-btn
                      width="120"
                      :disabled="invalid || !validated"
                      v-on:click="confirm()"
                      color="primary"
                      class="ma-2"
                      >Conferma</v-btn
                    >
                    <v-btn color="secondary" class="ma-2" width="120" v-on:click="cancel()"
                      >Annulla</v-btn
                    >
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import userManager from "../apis/users";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data() {
    return {
      password_confirm: String,
      password_view: String,
      user: {},
      repeat_password: "",
      editingUser: false,
      fetchingData: false,
      email_state: true,
      regions: {},
      roles: [
       
      ]
    };
  },

  components: {
    ValidationProvider,
    ValidationObserver
  },

  props: ["value"],

  mounted() {
    let roles = this.$store.state.user.roles.split(",");
    if (roles.indexOf('sa') >= 0) {
      this.roles.push({ name: "Root", value: "sa" });
      this.roles.push({ name: "Amministratore", value: "a" });
      
    }
    
    if (roles.indexOf('a') >= 0 || roles.indexOf('sa') >= 0) {
      this.roles.push({ name: "Revisore", value: "r" });
      this.roles.push({ name: "Utente", value: "u" });
    }
  },

  methods: {
    confirm: function() {
      this.handleSubmit();
    },

    closeDialog: function() {
      this.cancel();
    },

    cancel: function() {
      this.$emit("input"); // Input signal emitted from a dialog closes it, not clear in the documentation
    },

    checkFormValidity(callback) {
      this.email_state = true;
      if (this.user.email) {
        userManager
          .checkMail(this.user.email, this.user.id)
          .then(result => {
            if (result) {
              if (result > 0) {
                this.email_state = false;
                callback(false);
              }
            } else {
              callback(true);
            }
          })
          .catch(err => {
            console.log(err);
            this.email_state = false;
            callback(false);
          });
      }
    },

    handleSubmit() {
      this.checkFormValidity(res => {
        if (!res) return false;

        this.$refs.obs.reset();
        this.$emit("userConfigured", {
          editingUser: this.editingUser,
          user: this.user,
          tableItem: this.tableItem
        });
      });
    },

    resetModal() {
      this.repeat_password = "";
      this.user.password = "";
      this.user.email = "";
    },

    setModalUser(user, editing, regions) {
      this.user = Object.assign({}, user);
      this.editingUser = editing;
      this.regions = regions;
      if (this.regions.length && this.regions.length > 0 && this.regions[0].id == null) this.regions.splice(0,1);
      if (!this.editingUser) this.resetModal();
      /* eslint-disable no-unused-vars */

      if (editing) {
        requestAnimationFrame(() => {
          if (this.$refs.obs) {
            this.$refs.obs.validate();
          }
        });
      } else {
        requestAnimationFrame(() => {
          if (this.$refs.obs) this.$refs.obs.reset();
        });
      }

      /* eslint-enable no-unused-vars */
    }
  }
};
</script>
